<p-button 
    icon="pi pi-pencil"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Edit')"
    tooltipPosition="left"
    (onClick)="onClick()" />